/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBox from 'base/components/standalone/Box';

export const DynamicStandaloneBox = StandaloneBox;
export type DynamicStandaloneBoxProps = PropsFromComponent<typeof StandaloneBox>;

export const DynamicStandaloneBoxWith = (extras: DynamicStandaloneExtras): typeof StandaloneBox => {
    return function DynamicStandaloneBox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Box');
        return <StandaloneBox {...mergeProps({ options: { theme } }, props)} />;
    }
}